import React from 'react';
export function DecommissionCostsSection() {
  return <section data-id="element-3218">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-3219">
        <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-3220">
          4. Decommission Costs
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3221">
        <p data-id="element-3222">
          Finally, ROI should account for the residual value of the machine and
          the costs and benefits of disposing of or continuing to use the
          machine once payments are completed or the lease expires. A lower-cost
          machine's maintenance costs tend to increase during years four through
          12, negatively affecting part quality, scrap and tooling costs. Some
          high-performance machine tools, the authors write, may retain 50
          percent of their value by the three-year mark. These sorts of
          estimates ought to be included in ROI calculations.
        </p>
      </div>
    </section>;
}